import { getClimate } from '../helpers/helpers';

getClimate.addEventListener('click', () => {
  if (getClimate.getAttribute('status') == 'off') {
    getClimate.setAttribute('status', 'on');
  }
  else if (getClimate.getAttribute('status') == 'on') {
    getClimate.setAttribute('status', 'off');
  }
});
